<template>
  <base-modal
    hide-footer
    :size="'lg'"
    :modal-id="'inventory-create'"
    @hidden="$emit('onCloseModal')"
    @show="onModalOpen"
  >
    <template #modal-header>
      <div class="head-label">
        <b>Add Inventory</b>
      </div>
    </template>
    <b-form
      id="inventory-create-form"
      @submit.prevent="onSubmitForm"
    >
      <b-row>
        <b-col cols="12">
          <div class="d-flex w-100 mb-2">
            <div class="inventory-label required">
              Inventory Name&nbsp;<span class="text-danger">*</span>
            </div>
            <b-form-input
              id="name-inventory"
              v-model="formInventoryCreate.name"
              class="w-70"
              placeholder="Inventory Name"
              required
            />
          </div>
          <div class="d-flex w-100 mb-2">
            <div class="inventory-label">
              Detail
            </div>
            <b-form-textarea
              id="detail-inventory"
              v-model="formInventoryCreate.detail"
              class="w-70"
              :max-rows="2"
              :rows="2"
              placeholder="Detail"
            />
          </div>
        </b-col>
        <b-col cols="12">
          <div class="privilege-btn-wrp mt-2">
            <div class="d-flex justify-content-center">
              <cancel-button
                class="mr-1"
                @click.native="$emit('onCloseModal')"
              />
              <save-button
                :loading="loading"
                :type="'submit'"
                class="ml-1"
              />
            </div>
          </div>
        </b-col>
      </b-row>
    </b-form>
    <b-row class="modal-body-container mb-1" />
  </base-modal>
</template>

<script>
import BaseModal from '@/@core/components/base-modal/BaseModal.vue'
import useInventoryCreateModal from '../hooks/useInventoryCreateModal'

export default {
  components: { BaseModal },
  props: {},
  setup(props) {
    const {
      loading,
      formInventoryCreate,
      onModalOpen,
      onSubmitForm,
    } = useInventoryCreateModal()
    return {
      loading,
      formInventoryCreate,
      onModalOpen,
      onSubmitForm,
    }
  },
}
</script>

<style scoped>
@import '~@/assets/css/pages/inventory/inventory-create.css';
</style>
